import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=db14490c&scoped=true&"
import script from "./FaqItem.vue?vue&type=script&lang=ts&"
export * from "./FaqItem.vue?vue&type=script&lang=ts&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=db14490c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db14490c",
  null
  
)

export default component.exports